import api from './api';

const informeService = {
  getDashboardStats: async () => {
    try {
      const response = await api.get('/api/informes/dashboard/stats');
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        throw error.response.data.detail;
      }
      throw error.message || 'Error al obtener estadísticas';
    }
  },

  getEquiposPorTipo: async () => {
    try {
      const response = await api.get('/api/informes/equipos/por-tipo');
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        throw error.response.data.detail;
      }
      throw error.message || 'Error al obtener equipos por tipo';
    }
  },

  getEquiposPorCliente: async () => {
    try {
      const response = await api.get('/api/informes/equipos/por-cliente');
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        throw error.response.data.detail;
      }
      throw error.message || 'Error al obtener equipos por cliente';
    }
  },

  getFacturacionMensual: async (mes, anio) => {
    try {
      const response = await api.get('/api/informes/facturacion/mensual', {
        params: { mes, anio }
      });
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        throw error.response.data.detail;
      }
      throw error.message || 'Error al obtener facturación mensual';
    }
  },

  getHistorialCambios: async (params = { dias: 30 }) => {
    try {
      const finalParams = params && Object.keys(params).length ? params : { dias: 30 };
      const response = await api.get('/api/informes/historial-cambios', {
        params: finalParams
      });
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        throw error.response.data.detail;
      }
      throw error.message || 'Error al obtener historial de cambios';
    }
  },

  getFacturacionDetalle: async (clienteId, mes, anio) => {
    try {
      const response = await api.get(`/api/informes/facturacion-detalle/${clienteId}`, {
        params: { mes, anio }
      });
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        throw error.response.data.detail;
      }
      throw error.message || 'Error al obtener detalle de facturación';
    }
  },

  exportarPDF: async (clienteId, mes, anio) => {
    try {
      const response = await api.get(
        `/api/informes/facturacion/exportar-pdf`,
        {
          params: { cliente_id: clienteId, mes, anio },
          responseType: 'blob'
        }
      );
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        throw error.response.data.detail;
      }
      throw error.message || 'Error al exportar PDF';
    }
  },

  exportarExcel: async (clienteId, mes, anio) => {
    try {
      const response = await api.get(
        `/api/informes/facturacion/exportar-excel`,
        {
          params: { cliente_id: clienteId, mes, anio },
          responseType: 'blob'
        }
      );
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        throw error.response.data.detail;
      }
      throw error.message || 'Error al exportar Excel';
    }
  }
};

export default informeService;